import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {BuyerChoiceCreateComponent} from './buyer-choice-create/buyer-choice-create.component';
import {BuyerChoiceDeleteComponent} from './buyer-choice-delete/buyer-choice-delete.component';


@Component({
  selector: 'app-buyer-choice',
  templateUrl: './buyer-choice.component.html',
  styleUrls: ['./buyer-choice.component.scss'],
})

export class BuyerChoiceComponent implements OnInit {
  buyerChoiceForm: any;
  submitted: any;
  @Input() property: any;


  constructor(private fb: FormBuilder, private dialog: MatDialog) {
    this.buyerChoiceForm = this.fb.group({
      colorScheme: [''],
      mobileBenchOption: [''],
      dishAccessory: ['']
    });
  }

  ngOnInit(): void {

  }


  submit() {
    this.submitted = true;
    if (this.buyerChoiceForm.get('colorScheme').value === '' && this.buyerChoiceForm.get('mobileBenchOption').value === '' && this.buyerChoiceForm.get('dishAccessory').value === '') {
      return;
    }
  }

  openCreateBuyerChoiceDialog() {
    const dialogRef = this.dialog.open(BuyerChoiceCreateComponent, {
      width: '90%',
      maxWidth: '1000px',
      data: {property: this.property},
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        this.property.buyerChoice = result.buyerChoice;
      }
    });

  }

  openDeleteBuyerChoiceDialog(buyerChoice) {
    const dialogRef = this.dialog.open(BuyerChoiceDeleteComponent, {
      width: '90%',
      maxWidth: '1000px',
      data: {buyerChoice},
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        this.property.buyerChoice = null;
      }
    });
  }


}
